import Vue from "vue";
import Router from "vue-router";
import Home from "./components/HomePage.vue";
import AruszallitoProducts from "./components/AruszallitoProduct.vue";
import CsonakszallitoProducts from "./components/CsonakszallitoProduct.vue";
import MobilhazProducts from "./components/MobilhazProduct.vue";
import DetachableTrailers from "./components/DetachableTrailers.vue";
import ContainerTrailers from "./components/ContainerTrailers.vue";
import ExtraOptions from "./components/ExtraOptions.vue";
import Faq from "./components/Faq.vue";
import Contact from "./components/Contact.vue";
// import VueI18n from 'vue-i18n'

Vue.use(Router);
const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,

  scrollBehavior(to, from, savedPosition) {
    
    let url_string = window.location.href; //window.location.href
    let url = new URL(url_string);
    let setParameter = url.searchParams.get("set");

    if (to.hash) {
      return {selector: to.hash };
    } else if (setParameter != null) {      
      return;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "/:lang",
      name: "Home",
      component: Home,
    },
    {
      path: "/:lang/goodtransport",
      name: "AruszallitoProducts",
      component: AruszallitoProducts,
    },
    {
      path: "/:lang/boat",
      name: "CsonakszallitoProducts",
      component: CsonakszallitoProducts,
    },
    {
      path: "/:lang/tinyhousetrailer",
      name: "MobilhazProducts",
      component: MobilhazProducts,
    },
    {
      path: "/:lang/detachabletrailers",
      name: "DetachableTrailers",
      component: DetachableTrailers,
    },
    {
      path: "/:lang/containertrailers",
      name: "ContainerTrailers",
      component: ContainerTrailers,
    },
    {
      path: "/:lang/extraoptions",
      name: "ExtraOptions",
      component: ExtraOptions,
    },
    {
      path: "/:lang/faq",
      name: "Faq",
      component: Faq,
    },
    {
      path: "/:lang/contact",
      name: "Contact",
      component: Contact,
    },
  ],
});

router.beforeEach((to, from, next) => {
  // use the language from the routing param or default language
  let language = to.params.lang;
  if (!language) {
    language = "en";
    next({ path: "/en" });
  }

  // set the current language for vuex-i18n. note that translation data
  // for the language might need to be loaded first
  i18n.locale = language;
  next();
});

export default router;
